// Rolling graduation-year options that update automatically.
//
// Base range covers 4th grade → 12th grade of the current U.S. school year, i.e.
// [currentYear, currentYear + 8] = 9 classes.
//
// Rules (per spec, Feb 2027):
//   * On July 1 of every year we ADD one grad-year to the top (a rising 3rd → 4th
//     grader joins the pool). Between July and Aug the list is 10 wide.
//   * On September 1 of every year we DROP the current year (the class that
//     just graduated has moved on). Between Sep 1 and June 30 the list is 9
//     wide but starts at currentYear + 1.
export function gradYearOptions(now = new Date()) {
    const y = now.getFullYear();
    const m = now.getMonth() + 1; // 1-12
    let lo = y;
    let hi = y + 8;
    if (m >= 9) lo = y + 1;       // September 1+ → drop the just-graduated class
    if (m >= 7) hi = y + 9;       // July 1+ → add the newly rising class
    const out = [];
    for (let i = lo; i <= hi; i += 1) out.push(String(i));
    return out;
}

// --- Grade ↔ Grad-Year mapping for the merged main-page filter ---------------
// Anchored so that (as of the spec, mid-2026) 12th grade = class of 2027, and the
// senior class rolls UP by one every Sept 1 (12th → 2028 on Sept 1 2026, etc.).
import { GRADES } from "@/lib/sports";

export function seniorGradYear(now = new Date()) {
    const y = now.getFullYear();
    const m = now.getMonth() + 1; // 1-12
    // During a school year (Sept–Aug) the senior class graduates the following spring.
    // Sept–Dec → next calendar year; Jan–Aug → this calendar year. Rolls up each Sept 1.
    return y + (m >= 9 ? 1 : 0);
}

const gradeNum = (g) => parseInt(g, 10) || 0; // "8th" -> 8

// Graduation year for a grade label at a given date, e.g. gradeToGradYear("8th") -> "2031".
export function gradeToGradYear(grade, now = new Date()) {
    return String(seniorGradYear(now) + (12 - gradeNum(grade)));
}

// The grade one below (used for the Sept-1 carry-over safety): "8th" -> "7th", "2nd" -> null.
export function gradeOneBelow(grade) {
    const i = GRADES.indexOf(grade);
    return i > 0 ? GRADES[i - 1] : null;
}

// Merged main-page filter options: [{ grade, gradYear, label: "8th (2031)" }].
export function gradeFilterOptions(now = new Date()) {
    return GRADES.map((g) => {
        const yr = gradeToGradYear(g, now);
        return { grade: g, gradYear: yr, label: `${g} (${yr})` };
    });
}

// Distinct graduation years (ascending) for the Add/Edit "Grad Years" multi-select.
export function gradYearOptionsFromGrades(now = new Date()) {
    const set = new Set(GRADES.map((g) => gradeToGradYear(g, now)));
    return [...set].sort();
}
